import type { Cart } from '@/lib/types';
import { cartView } from '@/lib/display';
import { BatteryMark, PinMark, StatusMark } from './marks';

export function CartCard({ cart, onClick }: { cart: Cart; onClick?: () => void }) {
  const v = cartView(cart);
  return (
    <div
      onClick={onClick}
      className="flex cursor-pointer items-center gap-[13px] rounded-card bg-card px-4 py-[14px] shadow-soft hover:bg-hov"
    >
      <div className="min-w-0 flex-1">
        <div className="text-base font-bold leading-[1.3] text-ink">{cart.name}</div>
        <div
          className="overflow-hidden text-ellipsis whitespace-nowrap text-left text-xs font-semibold leading-normal text-faint"
          style={{ direction: 'rtl' }}
        >
          <span style={{ unicodeBidi: 'isolate', direction: 'ltr' }}>{v.serial}</span>
        </div>
        {v.lastHeard && (
          <div
            className="mt-[3px] text-[12.5px] font-semibold leading-[1.4]"
            style={{ color: v.lastHeardColor }}
          >
            {v.lastHeard}
          </div>
        )}
      </div>
      <div className="flex flex-none items-center gap-[13px]">
        <BatteryMark
          pct={cart.pct}
          plugged={cart.plugged}
          fill={v.battFill}
          border={v.battBorder}
          pctColor={v.pctColor}
        />
        <PinMark color={v.pinColor} />
        <StatusMark err={cart.err} triColor={v.triColor} chkColor={v.chkColor} />
      </div>
    </div>
  );
}
